import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // For React Router v5 or v6
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { baseUrl } from "../Service/Register";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const OrderDetails = () => {
  const [Data, setData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const getOrder = async () => {
    const formData2 = new FormData();
    formData2.append("orderNo", localStorage.getItem("OrderNO"));

    try {
      const response = await fetch(`${baseUrl}Order/GetAllImagesOfOrder`, {
        method: "POST",
        body: formData2,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      const data = await response.json();
      if (data && data.success === true) {
        const result = data.data;
        setData(result);
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleBackButton = () => {
    localStorage.removeItem("OrderID");
    localStorage.removeItem("OrderNO");
    navigate(-1);
  };

  const handleCancelOrder = async () => {
    // Show confirmation alert
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00015d",
      cancelButtonColor: "#ff6b00",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    });

    if (result.isConfirmed) {
      // Prepare the form data
      const formData = new FormData();
      formData.append("OrderId", localStorage.getItem("OrderID"));

      try {
        // Make the API call
        const response = await fetch(`${baseUrl}Order/CancelOrder`, {
          method: "PATCH",
          body: formData,
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        // If the request is successful, show success message
        if (response.ok) {
          toast.success("The order has been cancelled successfully.");
          navigate("/account");
        } else {
          // Handle unsuccessful response
          toast.error("Failed to cancel the order. Please try again.");
        }
      } catch (err) {
        // Handle error
        toast.error(err.message);
      }

      // Show success popup after order is successfully cancelled
      Swal.fire({
        title: "Cancelled!",
        text: "The order has been cancelled.",
        icon: "success",
        confirmButtonColor: "#00015d",
        confirmButtonText: "OK",
      });
    }
  };
  const handleModifyOrder = () => {
    // Show confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to modify this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00015d", // Color of the "Yes, modify it!" button
      cancelButtonColor: "#ff6b00", // Color of the "No, cancel" button
      confirmButtonText: "Yes, modify it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Save Data.primary to localStorage
        if (Data && Data.primary) {
          localStorage.setItem("Image", JSON.stringify(Data.primary));
        }
        navigate("/upload");
      } else {
        toast.info("Order modification canceled.");
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getOrder();
  }, []);

  return (
    <>
      <Header />
      <center>
        <section className="aboutBanner">
          <img
            src="/assets/img/Mosaico-Foto.webp"
            className="img-fluid"
            alt="Banner"
          />
        </section>
        <section class="galleryBox">
          <div className="mb-4  d-flex justify-content-end">
            <button onClick={handleBackButton}>Back</button>
          </div>
          <div class="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="titleBox">
                  <h2>Primary Photo</h2>
                </div>
                <div className="gallery-images">
                  <Link
                    to={`https://api.mosaicphotos.com.au/${Data.primary}`}
                    data-fancybox="gallery"
                  >
                    <img
                      src={`https://api.mosaicphotos.com.au/${Data.primary}`}
                      alt="Primary Document"
                      className="img-fluid"
                      style={{
                        marginRight: "10px",
                        height: "400px",
                        width: "300px",
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div className="row">
              <div className=" mx-auto">
                <div className="titleBox">
                  <h2>Cell Photos</h2>
                </div>
                <div className="gallery-images">
                  {Data.secondary &&
                    Data.secondary.map((cellImage, index) => (
                      <Link
                        key={index}
                        to={`https://api.mosaicphotos.com.au/${cellImage}`}
                        data-fancybox="gallery"
                      >
                        <img
                          src={`https://api.mosaicphotos.com.au/${cellImage}`}
                          alt={`Cell Document ${index + 1}`}
                          className="img-fluid"
                          style={{
                            margin: "10px",
                            height: "200px",
                            width: "200px",
                          }}
                        />
                      </Link>
                    ))}
                </div>
              </div>
            </div>

            <div>
              <button type="button" onClick={handleModifyOrder}>
                Modify Order
              </button>
              &nbsp; &nbsp;
              <button type="button" onClick={handleCancelOrder}>
                Cancel Order
              </button>
            </div>
          </div>
        </section>
      </center>
      <Footer />
    </>
  );
};

export default OrderDetails;
